import { Pipe, PipeTransform } from '@angular/core';
import { RFQ_QUOTE_DEFAULT, RfqQuote } from '@approot/models/rfq-quote.model';

@Pipe({
  name: 'quoteTimeLimitFilter'
})
export class QuoteTimeLimitFilterPipe implements PipeTransform {
  transform(quotes: RfqQuote[], currentTimestamp: number): RfqQuote[] {
    return quotes.filter(quote => {
      return (
        quote.timeLimit >= currentTimestamp ||
        !quote.timeLimit ||
        quote.frozenQuote
      );
    });
  }
}
